// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__ei7zL","sendOtp":"AuthorizeToLogin_sendOtp__3MnOE"};